export enum OrganizationStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

export enum AdmissionSignatureActions {
  SAVE_ADMISSION_SIGNATURE = "save-admission-signature",
}
